import React from 'react';
import PropTypes from 'prop-types';
import { Dialog as MuiDialog, DialogActions, DialogContent, DialogTitle as MuiDialogTitle } from '@mui/material';
import { withStyles } from '@mui/styles';
import { upperFirst, isString, isFunction } from 'lodash';

import { isOnlyMobile } from '../../services/isMobile';
import { DARK_THEME_COLOR } from '../../../const';

const titleStyle = {
  root: {
    fontWeight: 500,
    fontSize: 18,
    color: DARK_THEME_COLOR,
    padding: '24px 24px 12px 24px',
  },
};

const DialogTitle = withStyles(titleStyle)(MuiDialogTitle);

export function Dialog({
  onClose,
  title,
  modal,
  open,
  className,
  scroll,
  maxWidth,
  fullWidth,
  paperProps,
  contentClassName,
  contentStyle,
  children,
  actionsStyle,
  actions,
}) {
  const renderTitle = () => {
    if (title) {
      return <DialogTitle>{isString(title) ? upperFirst(title) : title}</DialogTitle>;
    }

    return null;
  };

  return (
    <MuiDialog
      open={open}
      className={className}
      scroll={scroll}
      maxWidth={maxWidth}
      onClose={(event, reason) => {
        if ((!modal || reason !== 'backdropClick') && isFunction(onClose)) {
          onClose(event, reason);
        }
      }}
      disableEscapeKeyDown={modal}
      fullWidth={fullWidth}
      fullScreen={isOnlyMobile}
      PaperProps={paperProps}
    >
      {renderTitle()}
      <DialogContent className={contentClassName} style={contentStyle}>
        {children}
      </DialogContent>
      <DialogActions style={actionsStyle}>{actions}</DialogActions>
    </MuiDialog>
  );
}

Dialog.propTypes = {
  open: PropTypes.bool,
  modal: PropTypes.bool,
  fullWidth: PropTypes.bool,
  actions: PropTypes.node,
  title: PropTypes.node,
  contentStyle: PropTypes.object,
  contentClassName: PropTypes.string,
  className: PropTypes.string,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  scroll: PropTypes.oneOf(['body', 'paper']),
  actionsStyle: PropTypes.object,
  paperProps: PropTypes.object,
  onClose: PropTypes.func,
};

Dialog.defaultProps = {
  open: false,
  modal: false,
  fullWidth: false,
  maxWidth: 'sm',
  scroll: 'paper',
};
